<template>
  <div class="builder__radio-option">
    <div class="builder__radio-option-name">
      <label>{{ option.display_title ? option.display_title : option.title }}:</label>
    </div>
    <div class="builder__radio-option-choices">
      <template v-if="!option.is_required">
        <div class="builder__radio-option-choice">
          <input type="radio"
                 class="builder__radio-option-choice-input"
                 :id="domId('none')"
                 :value="null"
                 v-model="selection"
          >
          <label class="builder__radio-option-choice-label" :for="domId('none')">
            <span class="builder__radio-option-choice-label-fake-input"></span>
            <span class="builder__radio-option-choice-label-text">None</span>
          </label>
        </div>
      </template>
      
      <template v-for="choice in option.choices">
        <div class="builder__radio-option-choice">
          <input type="radio"
                 class="builder__radio-option-choice-input"
                 :id="domId(choice.id)"
                 :value="choice.id"
                 v-model="selection"
          >
          <label class="builder__radio-option-choice-label" :for="domId(choice.id)">
            <span class="builder__radio-option-choice-label-fake-input"></span>
            <span class="builder__radio-option-choice-label-text">{{ choice.title }} {{ choice.price_adjustment_text }}</span>
          </label>
        </div>
      </template>
    </div>
    
    <div v-if="option.help_text" class="builder__step-note">
      {{ option.help_text }}
    </div>
    
  </div>
</template>

<script>
  export default {
    name: 'builder-option-radios',
    props: ['option'],
    
    methods: {
      domId(suffix) {
        return 'product-step-option-' + this.option.id + '-' + suffix
      },
    },
    
    computed: {
      selection: {
        get() { return this.option.selected_value },
        set(newValue) { this.$emit('input', newValue) },
      },
    },

  }
</script>



// WEBPACK FOOTER //
// Radios.vue?6481e0f1